import { gql } from "@apollo/client";


export const GET_ALL_TIPO_PRESTACIONES = gql`
query GET_ALL_TIPO_PRESTACIONES {
    GET_ALL_TIPO_PRESTACIONES {
      id      
      descripcion
    }
  }
`;


export const GET_USERS_BY_CAMPUS_OR_PROJECT = gql`
  query GET_USERS_BY_CAMPUS_OR_PROJECT($input: filterCompanyArea_Input) {
  GET_USERS_BY_CAMPUS_OR_PROJECT(input: $input) {
    id
    bussinesName
  }
}
`;

export const GET_ALL_TIPO_RESTRICCIONES_PRESTACIONES = gql`
query GET_ALL_TIPO_RESTRICCIONES_PRESTACIONES {
  GET_ALL_TIPO_RESTRICCIONES_PRESTACIONES {
      id      
      descripcion
    }
  }
`;

export const GET_ALL_PRESTACIONES = gql`
query GET_ALL_PRESTACIONES {
  GET_ALL_PRESTACIONES {
    id
    Titulo
    Descripcion
    URL
    fecha
    idTipoPrestacion
    TipoPrestacion
    Activa
    evaluable
    imgDefault
    sedes {
      id
      idPrestacion
      sede
    }
    areas {
      id
      idPrestacion
      Area
    }
    countColaboradores
    countRestricciones
    countComentarios
    promedio
    restricciones {
      id
      salInicial
      salTope
      tipoContrato      
      meses
      idTipoRestriccion
      otro
    }
    usuarios {
      id
      idUsuario
    }
    sedeByCounts {
      campus
      countBySede
    }
    commentBySedeCount {
      campus
      countByComentario
    }
    avgBySedes {
      campus
      promedioSede
    }
  }
}
`;


export const GET_PRESTACION_BY_ID = gql`
query GET_PRESTACION_BY_ID($getPrestacionByIdId: ID!) {
  GET_PRESTACION_BY_ID(id: $getPrestacionByIdId) {
    id
    Titulo
    Descripcion
    URL
    fecha
    idTipoPrestacion
    TipoPrestacion
    Activa
    evaluable
    imgDefault
    sedes {
      id
      idPrestacion
      sede
    }
    areas {
      id
      idPrestacion
      Area
    }
    countColaboradores
    countRestricciones
    countComentarios
    promedio
    restricciones {
      id
      salInicial
      salTope
      tipoContrato
      idTipoRestriccion
      meses
    }
    usuarios {
      id
      idUsuario
    }
  }
}
`;

export const CREATE_PRESTACION = gql`
mutation CREATE_PRESTACION($input: prestacion_Input) {
  CREATE_PRESTACION(input: $input) {
    id
  }
}
`;

export const UPDATE_PRESTACION_STATUS = gql`
mutation UPDATE_PRESTACION_STATUS($id:ID!) {
  UPDATE_PRESTACION_STATUS(id: $id)
}
`;


export const UPDATE_PRESTACION = gql`
mutation UPDATE_PRESTACION($updatePrestacionId: ID!, $input: prestacion_Input) {
  UPDATE_PRESTACION(id: $updatePrestacionId, input: $input)
}

`;



export const DELETE_PRESTACION = gql`
mutation DELETE_PRESTACION($deletePrestacionId: ID!) {
  DELETE_PRESTACION(id: $deletePrestacionId)
}
`;


export const DELETE_RESTRICCION = gql`
mutation DELETE_RESTRICCION($deleteRestriccionId: ID!) {
  DELETE_RESTRICCION(id: $deleteRestriccionId)
}
`;

export const DELETE_IMG_PRESTACION = gql`
mutation DELETE_IMG_PRESTACION($deleteRestriccionId: ID!) {
  DELETE_IMG_PRESTACION(id: $deleteRestriccionId)
}
`;

// ── Paquetes estándar ──────────────────────────────────────────────────────

export const GET_ALL_PAQUETES = gql`
query GET_ALL_PAQUETES {
  GET_ALL_PAQUETES {
    id
    nombre
    status
    idProject
    project { id proyectName client }
    prestaciones { id Titulo }
    countColaboradores
  }
}
`;

export const GET_SUBPROJECTS_BY_PROJECT = gql`
query GET_SUBPROJECTS_BY_PROJECT($idProject: ID!) {
  GET_SUBPROJECTS_BY_PROJECT(idProject: $idProject) {
    id
    nombre
  }
}
`;

export const CREATE_PAQUETE = gql`
mutation CREATE_PAQUETE($input: paquete_Input!) {
  CREATE_PAQUETE(input: $input) {
    id
    nombre
    status
  }
}
`;

export const UPDATE_PAQUETE = gql`
mutation UPDATE_PAQUETE($id: ID!, $input: paquete_Input!) {
  UPDATE_PAQUETE(id: $id, input: $input) {
    id
    nombre
    status
  }
}
`;

export const UPDATE_PAQUETE_STATUS = gql`
mutation UPDATE_PAQUETE_STATUS($id: ID!, $idUsuario: ID!) {
  UPDATE_PAQUETE_STATUS(id: $id, idUsuario: $idUsuario)
}
`;

export const DELETE_PAQUETE = gql`
mutation DELETE_PAQUETE($id: ID!, $idUsuario: ID!) {
  DELETE_PAQUETE(id: $id, idUsuario: $idUsuario)
}
`;

export const GET_HISTORIAL_PAQUETE = gql`
query GET_HISTORIAL_PAQUETE($idPaquete: ID!) {
  GET_HISTORIAL_PAQUETE(idPaquete: $idPaquete) {
    id
    idPaquete
    tipoMovimiento
    descripcion
    fecha
    nombreUsuario
  }
}
`;

// ── Historial de paquetes del colaborador (HU-PKG-05 Fase 2 · DBSB-94) ────────

export const GET_HISTORIAL_COLABORADOR_PAQUETES = gql`
query GET_HISTORIAL_COLABORADOR_PAQUETES($idColaborador: ID!) {
  GET_HISTORIAL_COLABORADOR_PAQUETES(idColaborador: $idColaborador) {
    id
    idColaborador
    idPaquete
    idPaqueteAnterior
    tipoMovimiento
    motivo
    idSolicitante
    idAprobador
    comentarioAprobacion
    fechaSolicitud
    fechaAprobacion
    estatus
    nombrePaquete
    nombrePaqueteAnterior
    nombreSolicitante
    nombreAprobador
  }
}
`;

// ── Reasignación de paquete con aprobación (HU-PKG-04 · DBSB-89/90/91) ───────

const SOLICITUD_CAMBIO_PAQUETE_FIELDS = `
    id
    idColaborador
    nombreColaborador
    idPaqueteAnterior
    nombrePaqueteAnterior
    idPaqueteNuevo
    nombrePaqueteNuevo
    motivo
    estatus
    idSolicitante
    nombreSolicitante
    idAprobador
    nombreAprobador
    comentarioAprobacion
    fechaSolicitud
    fechaAprobacion
`;

export const GET_PENDING_PACKAGE_CHANGES = gql`
query GET_PENDING_PACKAGE_CHANGES {
  GET_PENDING_PACKAGE_CHANGES {
    ${SOLICITUD_CAMBIO_PAQUETE_FIELDS}
  }
}
`;

export const GET_PACKAGE_CHANGE_PENDING_BY_COLABORADOR = gql`
query GET_PACKAGE_CHANGE_PENDING_BY_COLABORADOR($idColaborador: ID!) {
  GET_PACKAGE_CHANGE_PENDING_BY_COLABORADOR(idColaborador: $idColaborador) {
    ${SOLICITUD_CAMBIO_PAQUETE_FIELDS}
  }
}
`;

export const CREATE_PACKAGE_CHANGE_REQUEST = gql`
mutation CREATE_PACKAGE_CHANGE_REQUEST($input: solicitudCambioPaquete_Input!) {
  CREATE_PACKAGE_CHANGE_REQUEST(input: $input) {
    id
    estatus
  }
}
`;

export const APPROVE_PACKAGE_CHANGE = gql`
mutation APPROVE_PACKAGE_CHANGE($id: ID!, $idAprobador: ID!, $comentario: String) {
  APPROVE_PACKAGE_CHANGE(id: $id, idAprobador: $idAprobador, comentario: $comentario)
}
`;

export const REJECT_PACKAGE_CHANGE = gql`
mutation REJECT_PACKAGE_CHANGE($id: ID!, $idAprobador: ID!, $motivo: String!) {
  REJECT_PACKAGE_CHANGE(id: $id, idAprobador: $idAprobador, motivo: $motivo)
}
`;

export const GET_COMENTARIOS_PRESTACION = gql`
query GET_COMENTARIOS_PRESTACION($idPrestacion: ID!) {
  GET_COMENTARIOS_PRESTACION(idPrestacion: $idPrestacion) {
    id
    comentario
    dateAdd
    calificacion
    nombreColaborador
    apellido
    avatar
  }
}
`;